import { defineKey as T } from '@ha/intl';
import { ListingCostKey, ListingCostPayableAt } from '@ha/api/v2/types/Listing';

export const COSTS_TRANSLATIONS: { [key in ListingCostKey]: string } = {
  'security-deposit': T('StructuredCosts.create.deposits.securitydeposit'),
  'bedding-deposit': T('StructuredCosts.create.deposits.bedding'),
  'towel-deposit': T('StructuredCosts.create.deposits.towels'),
  'other-deposit': T('StructuredCosts.create.deposits.other'),
  'administration-fee': T(
    'StructuredCosts.create.additionalcosts.administrationfee',
  ),
  'utility-bills': T('StructuredCosts.create.utilitycosts'),
  'water-bill': T('water'),
  'gas-bill': T('gas'),
  'electricity-bill': T('electricity'),
  'internet-bill': T('internet'),
  'other-additional-costs': T('StructuredCosts.create.additionalcosts.other'),
  'final-cleaning': T('StructuredCosts.create.optionalservices.finalcleaning'),
  'cleaning-service': T('StructuredCosts.create.optionalservices.cleaning'),
  'overnight-guests': T(
    'StructuredCosts.create.optionalservices.overnightguests',
  ),
  'other-optional-costs': T(
    'StructuredCosts.create.optionalservices.otheroptionalcosts',
  ),
  'early-move-in': T('StructuredCosts.create.optionalservices.earlymovein'),
  'early-move-out': T('StructuredCosts.create.optionalservices.earlymoveout'),
  'late-move-in': T('StructuredCosts.create.optionalservices.latemovein'),
  'late-move-out': T('StructuredCosts.create.optionalservices.latemoveout'),
  'bike-rent': T('StructuredCosts.create.optionalservices.bike_rent'),
  'broadcasting-bill': T(
    'StructuredCosts.create.utilitycosts.broadcasting_fee',
  ),
  'cleaning-fee': T('StructuredCosts.create.additionalcosts.cleaning'),
  'full-board': T('StructuredCosts.create.optionalservices.full_board'),
  gym: T('StructuredCosts.create.optionalservices.gym'),
  'half-board': T('StructuredCosts.create.optionalservices.half_board'),
  parking: T('StructuredCosts.create.optionalservices.parking'),
  'towels-and-bedding': T(
    'StructuredCosts.create.optionalservices.towels_bedding',
  ),
  'end-early-fee': T('StructuredCosts.create.optionalservices.end_early'),
};

export const COSTS_PAYABLE_AT_TRANSLATIONS: {
  [key in ListingCostPayableAt]: string;
} = {
  'move-in': T('StructuredCosts.frequency.at_move_in'),
  'move-out': T('StructuredCosts.frequency.at_move_out'),
  'one-off': T('StructuredCosts.create.frequency.oneoff'),
  monthly: T('StructuredCosts.frequency.monthly'),
  'bi-monthly': T('StructuredCosts.frequency.every_2_months'),
  'bi-weekly': T('StructuredCosts.frequency.biweekly'),
  weekly: T('StructuredCosts.frequency.weekly'),
};

export const COSTS_REQUIRED_TRANSLATIONS = {
  required: T('StructuredCosts.required'),
  optional: T('StructuredCosts.optional'),
};
